const pricing = {
    mbMax: 1,
    fileMax: 10,
    minutesElapsed: 1 * 60
};

export default pricing